import { useAdminMode } from "@/contexts/admin-mode-provider";
import { MOBILE_BREAKPOINT } from "@/lib/device-format";
import { useSyncExternalStore } from "react";

const PHONE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const subscribeToPhoneQuery = (onChange: () => void): (() => void) => {
  const query = window.matchMedia(PHONE_QUERY);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
};
const subscribeToNothing = (): (() => void) => () => {};

const isPhoneScreen = (): boolean => window.matchMedia(PHONE_QUERY).matches;
const isNotWatched = (): boolean => false;

/**
 * Whether the company-mention debug is shown: admin mode, on a screen with a
 * pointer. A phone has no hover, so the bubble would only ever open on a tap,
 * over the answer being read.
 *
 * Every company tag calls this, so the screen width is only watched in admin
 * mode — not `useDeviceFormat`, which would add a listener and a second render
 * per tag for every customer. Read synchronously, the answer is right from the
 * first render, so the tag's wrapper does not swap (and remount its button)
 * once the width is known.
 */
export function useIsCompanyMentionDebugEnabled(): boolean {
  const { isAdminMode } = useAdminMode();
  const isPhone = useSyncExternalStore(
    isAdminMode ? subscribeToPhoneQuery : subscribeToNothing,
    isAdminMode ? isPhoneScreen : isNotWatched
  );
  return isAdminMode && !isPhone;
}
